module.exports = __webpack_public_path__ + "resources/img/img-glassdome-omnibus-en.e583114b462023dd0227d0fc882a9b6f.png";